import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full z-10" }
const _hoisted_2 = {
  class: "w-full mt-5",
  style: {"height":"600px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loader = _resolveComponent("Loader")!
  const _component_v_network_graph = _resolveComponent("v-network-graph")!
  const _component_MaterialLoad = _resolveComponent("MaterialLoad")!
  const _component_Sidebar = _resolveComponent("Sidebar")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Loader, { loader: _ctx.loader }, null, 8, ["loader"]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_v_network_graph, {
          ref: "graph",
          class: "graph",
          configs: _ctx.configs,
          nodes: _ctx.nodes,
          edges: _ctx.edges,
          layouts: _ctx.layouts,
          "event-handlers": _ctx.eventHandlers()
        }, null, 8, ["configs", "nodes", "edges", "layouts", "event-handlers"])
      ])
    ]),
    _createElementVNode("section", null, [
      _createVNode(_component_Sidebar, {
        visible: _ctx.material.visible,
        "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.material.visible) = $event)),
        baseZIndex: 10000,
        position: "full"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", null, [
            _createVNode(_component_MaterialLoad, {
              data: _ctx.material.data
            }, null, 8, ["data"])
          ])
        ]),
        _: 1
      }, 8, ["visible"])
    ])
  ], 64))
}